<template>
  <div
          v-if="id"
    :class="[
      'item',
      {
        'is-active': active
      }
    ]"
  >
    <div class="icon-area" @click="iconClick">
      <img :class="{ disabled: !visible }" :src="itemType | getSrcByType(that)" />
    </div>
    <!-- <i class="el-icon-star-off first-icon"></i> -->
    <!-- <div v-if="!!label" class="label">{{ label || '未命名' }}</div> -->
    <div
      v-if="!isEditName"
      :class="[
        'name',
        {
          nolable: !label
        }
      ]"
      @click="itemClick"
    >
      {{ name || '未命名' }}
    </div>
    <div
      v-else
      :class="[
        'input-wrapper',
        {
          nolable: !label
        }
      ]"
      @click="itemClick"
    >
      <input
        type="text"
        class="stand-input sp"
        v-model="name"
        v-focus
        v-if="isEditName"
        @click.stop="() => {}"
        @keyup.enter="handleCheck"
      />
    </div>
    <div class="btn">
      <template v-if="!isEditName">
        <i v-if="itemType == 1" class="el-icon-download" @click.stop="handleDownClick" style="margin:0 5px 0 0;"></i>
        <i
          v-if="isShowEditBtn"
          class="el-icon-edit"
          @click.stop="handleEditClick"
        ></i>
        <i v-else class="place"></i>
        <i class="el-icon-delete del" @click.stop="handleDelClick"></i>
      </template>
      <template v-else>
        <i class="el-icon-check" @click.stop="handleCheck"></i>
        <i class="el-icon-close del" @click.stop="handleCancel"></i>
      </template>
    </div>
  </div>
</template>

<script>
import adminareaSrc from '../../images/adminarea.svg';
import rectareaSrc from '../../images/rectarea.svg';
import pareaSrc from '../../images/parea.svg';
import pointSrc from '../../images/pointarea.svg';

import wadminSrc from '../../images/wch.svg';
import wrectSrc from '../../images/wc.svg';
import wpolySrc from '../../images/wp.svg';
import wpointSrc from '../../images/wpo.svg';
export default {
  props: {
    isShowEditBtn: {
      type: Boolean,
      default: true
    },
    id: Number,
    name: String,
    label: String,
    isEditName: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: Number || String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    getSrcByType(val, that) {
      if (that.active) {
        if (val == '2') {
          return wrectSrc;
        }

        if (val == '3') {
          return wpolySrc;
        }

        if (val == '4') {
          return wadminSrc;
        }
        return wpointSrc;
      } else {
        if (val == '2') {
          return rectareaSrc;
        }

        if (val == '3') {
          return pareaSrc;
        }

        if (val == '4') {
          return adminareaSrc;
        }
        return pointSrc;
      }
    }
  },
  directives: {
    focus: {
      // 当绑定元素插入到DOM中时...
      inserted: function (el) {
        // 聚焦元素
        el.focus();
      }
    }
  },
  watch: {
    name: {
      handler(val) {
        this.myName = val;
      },
      immediate: true
    },
    myName: {
      handler(val) {
        this.$emit('update:name', val);
      }
    }
  },
  data() {
    return {
      that: this,
      myName: ''
    };
  },
  methods: {
    itemClick() {
      this.$emit('itemClick');
    },
    iconClick() {
      this.$emit('iconClick');
    },
    handleCheck() {
      this.$emit('check');
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleEditClick() {
      this.$emit('edit');
    },
    handleDelClick() {
      this.$emit('del');
    },
    handleDownClick() {
      this.$emit('down');
    }
  }
};
</script>

<style lang="less" scoped>
.item {
  .stand-input.sp {
    height: 24px;
    font-size: 12px;
  }
  .btn {
    width: 60px;
    text-align: right;
  }

  height: 35px;
  align-items: center;
  display: flex;
  padding: 0px 5px 0px 10px;
  border-bottom: 1px #aaa dashed;
  cursor: pointer;
  &:hover {
    background-color: #a1c9e9;
  }
  &.is-active {
    background-color: #5dadff;
    color: #fff;
  }
  .first-icon {
    margin-right: 10px;
  }
  .label {
    width: 50px;
    font-size: 12px;
  }
  .input-wrapper {
    width: 120px;
    font-size: 12px;
    margin-right: 5px;
    &.nolable {
      width: 125px;
    }
  }
  .name {
    width: 120px;
    margin-right: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    line-height: 30px;
    &.nolable {
      width: 120px;
    }
  }
  .icon-area {
    margin-right: 8px;
    width: 18px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .disabled {
      background-color: #ccc;
    }
  }
  i {
    cursor: pointer;
  }
  .del {
    margin-left: 5px;
  }
  .place {
    display: inline-block;
    width: 14px;
    height: 100%;
  }
  // justify-content: space-between;
}
</style>
